export default "__VITE_ASSET__Dy4wm3vg__"